import { createFileRoute, redirect } from "@tanstack/react-router";

// Moved to Engineering (ADR-044): old links and bookmarks keep working.
export const Route = createFileRoute("/_app/manufacturing/engineering-boms")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/engineering/engineering-boms", search: search as never, replace: true });
  },
});
